import { z } from "zod";

export const phoneSchema = z
  .string()
  .min(1, "Phone number is required")
  .transform((value) => {
    const digitsOnly = value.replace(/\D/g, "");
    return digitsOnly.startsWith("1") && digitsOnly.length === 11
      ? digitsOnly.slice(1)
      : digitsOnly;
  })
  .refine((digitsOnly) => digitsOnly.length === 10, {
    message: "Phone number must be exactly 10 digits",
  })
  .refine(
    (digitsOnly) => {
      const areaCode = digitsOnly.slice(0, 3);
      return !/^[01]/.test(areaCode);
    },
    {
      message: "Invalid area code. US phone numbers cannot start with 0 or 1",
    }
  )
  .refine(
    (digitsOnly) => {
      const exchangeCode = digitsOnly.slice(3, 6);
      return !/^[01]/.test(exchangeCode);
    },
    {
      message: "Invalid exchange code. Cannot start with 0 or 1",
    }
  )
  .transform((digitsOnly) => {
    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
  });

export const seatSizeSchema = z.array(z.string())
  .min(1, "Please select at least one seat size")?.optional();

export const addressSchema = z.object({
  name: z.string().optional(),
});

export const profileSchema = z.object({
  photo: z.string().optional(),
  firstName: z
    .string()
    .min(1, "First name is required")
    .max(50, "First name too long"),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .max(50, "Last name too long"),
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  phone: phoneSchema,
  zipCode: z
    .string()
    .min(5, "Zip code must be at least 5 digits")
    .max(10, "Zip code too long")
    .optional(),
  streetName: z.string().optional(),
  address: addressSchema.optional(),
  state: z.string().optional(),
  city: z.string().optional(),
  country: z.string().default("United States"),
  suiteOrApt: z.string().optional(),
  size: seatSizeSchema,
});
